import { snapQuantity } from '@/models/productViewModel'

function stepSize(step) {
  return Math.max(1, Math.trunc(Number(step) || 0))
}

// The step, floor and cap a cart line moves by, read off its product's view model.
export function lineQuantityRules({ quantityStep, startingQuantity, maxPerOrder } = {}) {
  return { step: quantityStep, floor: startingQuantity, max: maxPerOrder }
}

export function smallestLineQuantity({ step = 1, floor = 0 } = {}) {
  return snapQuantity(1, { step, floor })
}

export function fittedLineQuantity(value, { step = 1, floor = 0, max = null } = {}) {
  const snapped = snapQuantity(value, { step, floor })
  if (snapped <= 0 || max == null || snapped <= max) return snapped
  const size = stepSize(step)
  const largest = Math.floor(Number(max) / size) * size
  return largest >= smallestLineQuantity({ step, floor }) ? largest : null
}

export function steppedUpQuantity(quantity, rules = {}) {
  const next = fittedLineQuantity(quantity + stepSize(rules.step), rules)
  return next != null && next > quantity ? next : null
}

export function steppedDownQuantity(quantity, rules = {}) {
  const next = quantity - stepSize(rules.step)
  if (next < smallestLineQuantity(rules)) return 0
  return fittedLineQuantity(next, rules) ?? 0
}

export function typedLineQuantity(value, rules = {}) {
  const requested = Math.trunc(Number(value) || 0)
  if (requested <= 0) return 0
  return fittedLineQuantity(requested, rules)
}
